import { render, staticRenderFns } from "./TransactionOverview.vue?vue&type=template&id=a54db0bc&scoped=true&"
import script from "./TransactionOverview.vue?vue&type=script&lang=js&"
export * from "./TransactionOverview.vue?vue&type=script&lang=js&"
import style0 from "./TransactionOverview.vue?vue&type=style&index=0&id=a54db0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54db0bc",
  null
  
)

export default component.exports